import { Badge as BadgeBoolean, BadgeProps } from "@mantine/core";
import { IColor, variantColors } from "../../../utils/selectColors";

interface IProps extends BadgeProps {
  statusYes?: boolean;
}

const TagBoolean = ({ statusYes, ...props }: IProps) => {
  const colorSelected: IColor = !!statusYes
    ? IColor.success
    : IColor.disapproved;
  const selectedVariant = variantColors[colorSelected];

  return (
    <BadgeBoolean
      {...props}
      styles={{
        root: {
          color: selectedVariant.color,
          background: selectedVariant.bg,
          padding: "4px 8px",
          height: "30px",
          fontSize: "14px",
          borderRadius: "20px",
        },
      }}
    >
      {statusYes ? "Sim" : "não"}
    </BadgeBoolean>
  );
};

export default TagBoolean;
